"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumb = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _breadcrumbModule = _interopRequireDefault(require("@albelli/arc-3/lib/breadcrumb.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Breadcrumb = _ref => {
  let {
    children,
    className,
    borderless,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("ol", _extends({
    className: (0, _classnames.default)(_breadcrumbModule.default["arc3-breadcrumb"], className, {
      [_breadcrumbModule.default["--borderless"]]: borderless
    }),
    "data-cy": "arc3-breadcrumb"
  }, props), _react.default.Children.map(children, child => child && /*#__PURE__*/_react.default.createElement("li", null, child)));
};

// Breadcrumb.propTypes = {
//   /** Array of links */
//   children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
//   /** Remove the default bottom border */
//   borderless: PropTypes.bool,
//   /** Custom CSS classes */
//   className: PropTypes.string
// };
exports.Breadcrumb = Breadcrumb;